// Convert string country code to regional indicator emoji
// https://symbl.cc/en/1F1E6/
const regionalIndicatorOffset = 0x1f1e6; // Start of the flags
const asciiOffset = 0x41; // Alphabet offset in ascii table
export const getFlagEmoji = (countryCode: string) => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => regionalIndicatorOffset - asciiOffset + char.charCodeAt(0));

  return String.fromCodePoint(...codePoints);
};

export const DEFAULT_COUNTRY_CODE = 'GB';

export const getCountryCodeFromTLD = (): string => {
  const split = window.location.hostname.split('.');
  // No TLD
  if (split.length < 2) {
    return DEFAULT_COUNTRY_CODE;
  }
  const tld = split[split.length - 1];
  // not alphabetical (ip address)
  if (!/^[a-zA-Z]+$/.test(tld)) {
    return DEFAULT_COUNTRY_CODE;
  }
  // the iso for UK is GB
  if (tld === 'uk') {
    return DEFAULT_COUNTRY_CODE;
  }
  // Rest of european countries have tld === iso country code
  return tld.toUpperCase();
};

export const timezoneToCountryCode: Record<string, string> = {
  'Europe/Vienna': 'AT',
  'Europe/Brussels': 'BE',
  'Europe/Sofia': 'BG',
  'Europe/Zurich': 'CH',
  'Europe/Nicosia': 'CY',
  'Europe/Prague': 'CZ',
  'Europe/Berlin': 'DE',
  'Europe/Busingen': 'DE',
  'Europe/Copenhagen': 'DK',
  'Europe/Tallinn': 'EE',
  'Europe/Madrid': 'ES',
  'Europe/Helsinki': 'FI',
  'Europe/Paris': 'FR',
  'Europe/Belfast': 'GB',
  'Europe/London': 'GB',
  'Europe/Athens': 'GR',
  'Europe/Zagreb': 'HR',
  'Europe/Budapest': 'HU',
  'Europe/Dublin': 'IE',
  'Europe/Rome': 'IT',
  'Europe/Vilnius': 'LT',
  'Europe/Luxembourg': 'LU',
  'Europe/Riga': 'LV',
  'Europe/Malta': 'MT',
  'Europe/Amsterdam': 'NL',
  'Europe/Oslo': 'NO',
  'Europe/Warsaw': 'PL',
  'Europe/Lisbon': 'PT',
  'Europe/Bucharest': 'RO',
  'Europe/Stockholm': 'SE',
  'Europe/Ljubljana': 'SI',
  'Europe/Bratislava': 'SK',
};

export const getCountryCodeFromTimezone = (): string => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const countryCode: string | undefined = timezoneToCountryCode[timeZone];
  return countryCode || DEFAULT_COUNTRY_CODE;
};

export const allTWCountryCodes = [
  'AT',
  'BE',
  // 'BG',
  // 'CY',
  // 'CZ',
  'DE',
  // 'DK',
  // 'EE',
  'ES',
  // 'FI',
  'FR',
  'GB',
  'GR',
  // 'HR',
  // 'HU',
  'IE',
  'IT',
  'LT',
  // 'LU',
  'LV',
  // 'MT',
  'NL',
  // 'NO',
  // 'PL',
  'PT',
  'CH',
  // 'RO',
  // 'SE',
  // 'SI',
  // 'SK',
];
